import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UserPlus, Phone, Flame, Send, Users, FileText, Award, TrendingUp
} from 'lucide-react';
import type { DashboardKpis } from '../../services/dashboard.service';

interface KpiRowProps {
  kpis: DashboardKpis | null;
  loading?: boolean;
}

// Schritt 2: Kennzahlen auf dem Workflow-Modell (Regel 37).
// „Neu / unbearbeitet" zählt nur Kandidaten ohne jeden Journaleintrag (Regel 38).
const KPI_CONFIG = [
  { key: 'neu_unbearbeitet', label: 'Neu / unbearbeitet', icon: UserPlus, color: '#3B82F6', filter: '?stage=NEW' },
  { key: 'in_bearbeitung', label: 'In Bearbeitung', icon: Phone, color: '#6366F1', filter: '?stage=IN_PROGRESS' },
  { key: 'kontaktversuch', label: 'Kontaktversuch', icon: Flame, color: '#F59E0B', filter: '?stage=CONTACT_ATTEMPTED' },
  { key: 'gesprochen', label: 'Gesprochen', icon: Send, color: '#8B5CF6', filter: '?stage=CONTACTED' },
  { key: 'qualifiziert', label: 'Qualifiziert', icon: Users, color: '#0EA5E9', filter: '?stage=QUALIFIED' },
  { key: 'aktiv', label: 'Aktiv', icon: FileText, color: '#10B981', filter: '?stage=ACTIVE' },
  { key: 'talentpool', label: 'Talentpool', icon: Award, color: '#64748B', filter: '?stage=TALENT_POOL' },
  { key: 'gesamt', label: 'Gesamt', icon: TrendingUp, color: '#6B7280', filter: '' },
] as const;

const KpiRow: React.FC<KpiRowProps> = ({ kpis, loading }) => {
  const navigate = useNavigate();

  const handleClick = (filter: string) => {
    if (filter) {
      navigate(`/recruiting${filter}`);
    }
  };

  return (
    <div className="kpi-row">
      {KPI_CONFIG.map(({ key, label, icon: Icon, color, filter }) => {
        const value = kpis ? (kpis as any)[key] ?? 0 : 0;
        return (
          <button
            key={key}
            className={`kpi-card ${filter ? 'clickable' : ''}`}
            onClick={() => handleClick(filter)}
            disabled={!filter}
            title={filter ? `${label} anzeigen` : undefined}
          >
            <div className="kpi-icon-wrapper" style={{ background: `${color}15`, color }}>
              <Icon size={20} />
            </div>
            <div className="kpi-content">
              <span className="kpi-value">
                {loading ? '–' : value}
              </span>
              <span className="kpi-label">{label}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default KpiRow;
